import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-51b14953"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-box cm-ui-mb10" }
const _hoisted_2 = { class: "tree-box el-card" }
const _hoisted_3 = { class: "custom-tree-node" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "father-name" }
const _hoisted_6 = { class: "item-name" }
const _hoisted_7 = { class: "item-name" }
const _hoisted_8 = {
  key: 1,
  class: "item-name"
}
const _hoisted_9 = {
  key: 1,
  class: "item-name"
}
const _hoisted_10 = {
  key: 1,
  class: "cm-ui-ml5"
}
const _hoisted_11 = { class: "father-name title" }
const _hoisted_12 = { class: "father-name title" }
const _hoisted_13 = {
  key: 0,
  class: "validation-error-banner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "container scan-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_select, {
          size: "small",
          modelValue: _ctx.scanType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scanType) = $event)),
          placeholder: _ctx.$t('common.phPleaseSelect'),
          onChange: _ctx.changeSelect
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions[_ctx.system_tab], (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                value: item.value,
                label: item.label,
                key: item.key
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "onChange"]),
        _createVNode(_component_el_button, {
          class: "cm-ui-ml10",
          type: _ctx.editMode?'primary':'',
          size: "small",
          onClick: _ctx.toggleEditMode
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.editMode ? _ctx.t('groupPolicySettings.scanDoneEditing') : _ctx.t('groupPolicySettings.scanEditThreshold')), 1)
          ]),
          _: 1
        }, 8, ["type", "onClick"]),
        _createVNode(_component_el_button, {
          class: "confirm-btn",
          type: "primary",
          size: "small",
          onClick: _ctx.saveScanItemIds,
          disabled: _ctx.btnStatus
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.scanConfirm')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_tree, {
          ref: "treeRef",
          data: _ctx.ALL_ITEMS,
          "node-key": "id",
          props: _ctx.defaultProps,
          onCheckChange: _ctx.changeCheck,
          onNodeClick: _ctx.nodeCheck,
          "default-expand-all": "",
          "show-checkbox": "",
          "check-on-click-node": ""
        }, {
          default: _withCtx(({ node, data }) => [
            _createElementVNode("div", _hoisted_3, [
              (data.fatherName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(data.fatherName), 1),
                    (_ctx.isCustomizableItem(data.id))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.editMode)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("span", _hoisted_6, "- " + _toDisplayString(_ctx.parseLabelParts(node.label).prefix), 1),
                                _createVNode(_component_el_input_number, {
                                  class: "custom-value-input",
                                  modelValue: _ctx.customValues[data.id],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.customValues[data.id]) = $event),
                                  min: (_ctx.getCustomItemMeta(data.id) || {}).min,
                                  max: (_ctx.getCustomItemMeta(data.id) || {}).max,
                                  controls: false,
                                  size: "mini",
                                  onChange: _ctx.validateConstraints
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max", "onChange"]),
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.parseLabelParts(node.label).suffix), 1),
                                _createVNode(_component_el_button, {
                                  class: "reset-btn",
                                  type: "text",
                                  size: "small",
                                  onClick: _withModifiers(($event: any) => (_ctx.resetCustomValue(data.id)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.scanResetDefault')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ], 64))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, "- " + _toDisplayString(_ctx.t('baselineRepairItems.n.' + data.id.replace(/\./g, '_'), [_ctx.customValues[data.id]])), 1))
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "- " + _toDisplayString(node.label), 1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`icon${data.id}`)
                    }, null, 2),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(node.label), 1),
                    _createElementVNode("span", _hoisted_12, " (" + _toDisplayString(_ctx.checkCount[data.id]) + "/" + _toDisplayString(data.items.length) + ")", 1)
                  ]))
            ])
          ]),
          _: 1
        }, 8, ["data", "props", "onCheckChange", "onNodeClick"])
      ]),
      (_ctx.editMode && _ctx.validationConstraintError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.t('groupPolicySettings.scanCustomConstraintError')), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  })), [
    [_directive_loading, _ctx.loading]
  ])
}